import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { mergeSearch } from '../../cdl-react-components/utilities'

const link = (props) => {
    const { href, parameters } = props

    const query =
        parameters &&
        parameters.length > 0 ?
            `query=${JSON.stringify(parameters.map(x => ({ ...x, value: encodeURIComponent(x.value) })))}` :
            'query='
    const search = mergeSearch(window.location.search, query, ['url', 'id', 'page'])

    if (typeof href === 'string') {
        return href.startsWith('http') ?
            (<a
                id={props.id || ''}
                className={props.className || ''}
                onClick={props.onClick || (() => {})}
                title={props.title || ''}
                href={href || '/'}
                style={props.style || {}}
                draggable="false"
                target="_blank" rel="noreferrer">
                {props.children}
            </a>) :
            (<Link
                id={props.id || ''}
                className={props.className || ''}
                onClick={props.onClick || (() => {})}
                title={props.title || ''}
                to={{ pathname: href || '/', search }}
                style={props.style || {}}
                draggable="false">
                {props.children}
            </Link>)
    }
    else if (typeof href === 'object') {
        return (
            <Link
                id={props.id || ''}
                className={props.className || ''}
                onClick={props.onClick || (() => {})}
                title={props.title || ''}
                to={href}
                style={props.style || {}}
                draggable="false">
                {props.children}
            </Link>)
    }
    else {
        throw Error(`Invalid 'href' type passed. expected 'string' or 'object', but got '${typeof href}'`)
    }
}

const mapStateToProps = ({ search }) => ({
    parameters: search.parameters
})

export default connect(mapStateToProps)(link)